/* eslint-disable jsx-a11y/anchor-is-valid */
import { EyeOutlined, FilePdfOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Col, Row, Tooltip } from 'antd';
import { Text, Box } from 'atoms';
import { StatusAction } from 'components';
import { ACL } from 'components/common';
import { getLocalDate, getLocalTime } from 'utils/helpers';
import { getCRF } from 'store/clientSlice';

// pdf/docx/
const pdf = 'pdf';
const docx = 'docx';
const xlsx = 'xlsx';

export const ClientTableConfig = [
	{
		title: 'Client Name',
		dataIndex: 'client_info',
		key: 'client_info',
		hidden: false,
		render: (client_info) => <Text overFlow="hidden">{client_info?.client_name || ''}</Text>,
	},
	{
		title: 'Primary Cost Center ',
		dataIndex: 'client_info',
		key: 'client_info',
		hidden: false,
		render: (client_info) => (
			<Text overFlow="hidden">{client_info?.primary_cost_center || ''}</Text>
		),
	},
	{
		title: 'State',
		dataIndex: 'client_info',
		key: 'client_info',
		hidden: false,
		render: (client_info) => <Text overFlow="hidden">{client_info?.state || ''}</Text>,
	},
	{
		title: 'City',
		dataIndex: 'client_info',
		key: 'client_info',
		hidden: false,
		render: (client_info) => <Text overFlow="hidden">{client_info?.city || ''}</Text>,
	},
	{
		title: 'username',
		dataIndex: 'username',
		key: 'username',
		hidden: false,
		render: (username) => <Text overFlow="hidden">{username || ''}</Text>,
	},
	{
		title: 'Created at',
		dataIndex: 'created_at',
		key: 'created_at',
		hidden: false,
		render: (created_at) => (
			<Box>
				<Text overFlow="hidden">{getLocalDate(created_at)}</Text>

				<Text overFlow="hidden" fontStyle="italic">
					{getLocalTime(created_at)}
				</Text>
			</Box>
		),
	},
	{
		title: 'CRF',
		dataIndex: 'id',
		key: 'id',
		hidden: false,
		render: (id) => (
			<Row gutter={16}>
				<Col>
					<Tooltip title="Download PDF">
						<FilePdfOutlined
							style={{
								color: 'red',
								fontSize: '14px',
							}}
							onClick={getCRF({ id, type: pdf })}
						/>
					</Tooltip>
				</Col>
				<Col>
					<Tooltip title="Download DOC">
						<FilePdfOutlined
							style={{
								color: 'blue',
								fontSize: '14px',
							}}
							onClick={getCRF({ id, type: docx })}
						/>
					</Tooltip>
				</Col>
				<Col>
					<Tooltip title="Download xlsx">
						<FilePdfOutlined
							style={{
								color: 'green',
								fontSize: '14px',
							}}
							onClick={getCRF({ id, type: xlsx })}
						/>
					</Tooltip>
				</Col>
			</Row>
		),
	},

	{
		title: 'View',
		dataIndex: 'id',
		key: 'id',
		hidden: false,
		render: (id) => (
			<Box>
				<Row gutter={16} justify="space-between">
					<Link to={`/client/edit/${id}`}>
						<EyeOutlined />
					</Link>
				</Row>
			</Box>
		),
	},
	{
		title: 'Action',
		dataIndex: 'id',
		key: 'id',
		hidden: false,
		render: (id, record) => (
			<ACL action="update" module="client">
				<StatusAction statusData={record?.is_active} userType="client" id={id} />
			</ACL>
		),
	},
];
